import moment from "moment";

// ✅ Time formatting utilities
export const formatNumericToTime = (numericValue) => {
  if (numericValue === undefined || numericValue === null) {
    return "00:00";
  }

  let formattedHours = "00";
  let formattedMinutes = "00";
  let finaltime = "00";

  if (numericValue.toString().includes(".")) {
    let [hoursPart, minutesPart] = numericValue.toString().split(".");

    if (hoursPart !== 0) {
      const hours = parseInt(hoursPart) || 0;
      const minutes = minutesPart;
      formattedHours = hours.toString().padStart(2, "0");
      formattedMinutes =
        minutes.toString().length === 1 ? minutes.toString().padEnd(2, "0") : minutes;
      finaltime = `${formattedHours}:${formattedMinutes}`;
    } else {
      formattedMinutes =
        minutesPart.toString().length === 1
          ? `00:${minutesPart.toString().padEnd(2, "0")}`
          : `00:${minutesPart}`;
      finaltime = `${formattedMinutes}`;
    }
  } else {
    let hoursPart = numericValue.toString();
    formattedHours =
      hoursPart.length === 1
        ? `${hoursPart.toString().padStart(2, "0")}:00`
        : hoursPart.length === 2
          ? `${hoursPart}:00`
          : hoursPart;
    finaltime = `${formattedHours}`;
  }

  return `${finaltime}`;
};

export const convertToDecimal = (timeString) => {
  const [hours, minutes] = timeString.split(":").map(Number);
  return `${hours}.${minutes.toString().padStart(2, "0")}`;
};

export const calculateTotalHours = (clockIn, clockOut) => {
  if (!clockIn || !clockOut) return 0;
  const inTime = new Date(clockIn);
  const outTime = new Date(clockOut);
  const diffInMs = outTime - inTime;
  const diffInHours = diffInMs / (1000 * 60 * 60);
  return parseFloat(diffInHours.toFixed(2));
};

export const calculateDecimalHours = (startTime, endTime) => {
  if (!startTime || !endTime) return 0;
  const [startH, startM] = startTime.split(":").map(Number);
  const [endH, endM] = endTime.split(":").map(Number);
  const start = startH * 60 + startM;
  const end = endH * 60 + endM;
  const diffMinutes = end - start;
  if (diffMinutes <= 0) return 0;
  return parseFloat((diffMinutes / 60).toFixed(2));
};

// ✅ File conversion utilities
export const base64ToFile = (base64String, fileName, mimeType) => {
  if (!base64String || typeof base64String !== "string" || !base64String.includes(",")) {
    console.error("base64ToFile-> Error As Its Not A Valid base64: ", base64String);
    return null;
  }

  const byteCharacters = atob(base64String.split(",")[1]);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new File([byteArray], fileName, { type: mimeType });
};

export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

// ✅ Date utilities
export const formatTimesheetDate = (date) => {
  return moment(date).format("MMMM DD, YYYY");
};

// ✅ Data validation
export const validateTimesheetData = (selectedJob) => {
  return selectedJob && selectedJob.length > 0 && selectedJob.every(job => job && job.hours > 0);
};

// ✅ Goal handling utilities
export const updateGoalInJobArray = (currentData, indexForGoal, goalIndex, item, isAddingNew = false) => {
  const updatedData = [...currentData];
  
  if (!updatedData[indexForGoal].timesheetGoalsArray) {
    updatedData[indexForGoal].timesheetGoalsArray = [];
  }

  const goalArray = updatedData[indexForGoal].timesheetGoalsArray;
  const goalData = {
    goalName: item.goalName,
    time: 0,
    goalId: item.goalId,
    categoryName: "",
    categoryId: "",
    goalDateTimeModal: false
  };

  if (isAddingNew) {
    goalArray.push(goalData);
  } else if (goalArray[goalIndex]) {
    Object.assign(goalArray[goalIndex], goalData);
  }

  return updatedData;
};

// ✅ Common API request builders
export const buildTimesheetSearchList = (flag, userId) => {
  return flag === "all"
    ? [{ UserId: userId }]
    : [
        { isSent: flag === "unsent" ? false : true },
        { UserId: userId }
      ];
};

export const buildGoalRequestPayload = (userId) => {
  return {
    PageNr: 1,
    FullSearch: "",
    UserId: userId,
    IncludeRecordNr: true,
    SearchList: [{ createdBy: userId }]
  };
};

export const buildTimesheetRequestPayload = (flag, userId) => {
  return {
    PageNr: 1,
    NrOfRecPerPage: 100,
    FullSearch: "",
    UserId: userId,
    IncludeRecordNr: true,
    SearchList: buildTimesheetSearchList(flag, userId),
    SortList: []
  };
};

// ✅ Data sorting utilities
export const sortTimesheetData = (data) => {
  return data.sort((a, b) => {
    if (a.isSent !== b.isSent) return a.isSent ? 1 : -1;
    return new Date(b.timesheetDate) - new Date(a.timesheetDate);
  });
};

// ✅ Goal formatting utilities
export const formatGoalsArray = (goals) => {
  return goals.map((goal) => ({
    ...goal,
    key: goal.id,
    value: goal.name
  }));
};
